var flexFont = function () {
  var divs = document.getElementsByClassName('flexFont')
  for (var i = 0; i < divs.length; i++) {
    var relFontsize = divs[i].offsetWidth * 0.07
    if ($(window).width() < 768) {
      divs[i].style.fontSize = relFontsize + 'px'
    } else {
      divs[i].style.fontSize = ''
    }
  }
}

$(window).load(function () {
  flexFont()
})

$(window).resize(function () {
  flexFont()
})
